var PlotConfigBuilder = /** @class */ (function () {
    function PlotConfigBuilder(props) {
        this.props = props;
    }
    return PlotConfigBuilder;
}());
export { PlotConfigBuilder };
//# sourceMappingURL=types.js.map